import Component from "@tunnel-components/@pages/lapi-tmd/incidents/component";
import * as React from "react";
import { connect } from "react-redux";
import * as Lodash from "lodash";
import {
  IncidentstmdLoadedActionCreator,
  QualificationIncidentTmdActionCreator,
} from "@tunnel-store/index";
import * as Utils from "@Cyclope-Utils/index";
// import { LapiAndTmpLoadedActionCreator } from '@tunnel-store/index';

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name render
 * @infos "https://reactjs.org"
 */
class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @property { object }      state
     */
    this.state = {
      actionLoader: [],
      acknowledged: [],
      incidentData: [], // Liste de caméra
      currentPageNumbers: 1, // nouvelle pagination
      errorserver: false,
      // itemsPerPage:1,
      itemPerRow: 3,
      loading: false,
      // totalElements:1,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    // Mise à jour de la valeur du ScrollTop
    this.onUpdateScrollTop = this.onUpdateScrollTop.bind(this);
    // nouvelle pagination
    this.onUpdateCurrentPageNumber = this.onUpdateCurrentPageNumber.bind(this);
    // nombre d'incidents par ligne
    this.onChangeItemPerRow = this.onChangeItemPerRow.bind(this);
    this.onClickOnglet = this.onClickOnglet.bind(this);
    this.onQualified = this.onQualified.bind(this);
  }
  /**
   * Qualification des incidents
   * @public
   * @method onQualified
   * @param { any } event
   * @param { number } id
   * @param { number } isQualify
   * @param { number } index
   * @infos "https://reactjs.org"
   */
  public onQualified = (id: number, isQualify: number, index: number) => (
    event: any
  ) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    /**
     * @constant
     * @name actionLoader
     * @type boolean[]
     */
    const acknowledged: boolean[] = [];
    const actionLoader: boolean[] = [];
    for (let i = 0; i <= Math.ceil(this.state.actionLoader.length); i++) {
      actionLoader.push(false);
      acknowledged.push(false);
    }
    actionLoader[index] = true;
    acknowledged[index] = true;
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any) => ({ actionLoader, acknowledged }));

    setTimeout(() => {
      this.props.QualificationIncidentTmdActionCreator(id).then(() => {
        this.props.IncidentstmdLoadedActionCreator();
      });
    }, 1000);
  };
  /**
   * @method onUpdateScrollTop
   * @description: MAJ du scrollIncident
   * @param { any } target
   * @infos "https://reactjs.org"
   */
  public onUpdateScrollTop = (target: any) =>
    this.setState((state: any) => ({
      errorserver: false,
      scrollIncident: Number(target),
    }));
  /**
   * @method onChangeItemPerRow
   * @description: MAJ du nombre de column
   * @index { number } event
   * @infos "https://reactjs.org"
   */
  public onChangeItemPerRow = (target: any) =>
    this.setState((state: any) => ({
      errorserver: false,
      itemPerRow: Number(target),
    }));
  /**
   * @method onUpdateCurrentPageNumber
   * @description: MAJ de la page courante
   * @param { any } target
   * @infos "https://reactjs.org"
   */
  public onUpdateCurrentPageNumber = (target: any) =>
    this.setState((state: any) => ({
      errorserver: false,
      currentPageNumbers: Number(target),
    }));

  /**
   * MAJ des données relatifs aux incidents
   * @public
   * @method onCheckAction
   * @param { number } current
   * @param { number } items
   * @infos "https://reactjs.org"
   */
  public onCheckAction = () => {
    this.props
      .IncidentstmdLoadedActionCreator()
      .then(() => {
        if (!Lodash.isUndefined(this.props.error)) {
          this.setState({ errorserver: true });
        }
      })
      .then(() => this.setState({ loading: false }));
  };

  /**
   * Modification des états des onglet
   * @method onClickOnglet
   * @param { any } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onClickOnglet = (param: string, index: number) => (
    event: any
  ): void => {
    /**
     * @constant
     * @name ongletActive
     * @type any[]
     */
    const ongletActive: any[] = [];
    {
      /** boucle */
    }
    for (let i = 0; i < 1; i++) {
      ongletActive.push(false);
    }
    ongletActive[index] = true;
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.error !== this.props.error) {
      {
        /** vérification de l'existence de l'élement  */
      }
      if (!Lodash.isUndefined(nextProps.error)) {
        this.setState((state: any): any => ({ errorserver: true }));
      }
    } else if (nextProps.data !== this.props.data) {
      /**
       * @constant
       * @name actionLoader
       * @type boolean[]
       */
      const actionLoader: boolean[] = [];
      const acknowledged: boolean[] = [];
      {
        /** boucle  */
      }
      for (let i = 0; i <= Math.ceil(nextProps.data.length); i++) {
        actionLoader.push(false);
        acknowledged.push(false);
      }
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        actionLoader,
        acknowledged,
        incidentData: nextProps.data,
        errorserver: false,
        itemsPerPage: nextProps.data.length,
        totalElements: nextProps.data.length,
      }));
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      loading: false,
      errorserver: false,
      segmentation: false,
    }));
    // this.removeEvent();  // remove event :  visibilitychange
  }

  /**
   * Cycle de vie d'un composant react LapiAndTmpLoadedActionCreator
   * @method render
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    {
      /** Persistance de la possition du menu */
    }
    Utils.persistentColumnPosition();
    return (
      <Component
        {...this.props}
        {...this.state}
        // scrollIncident
        onUpdateScrollTop={this.onUpdateScrollTop}
        //
        onQualified={this.onQualified}
        onUpdateCurrentPageNumber={this.onUpdateCurrentPageNumber} // Changement de la page courante
        onChangeItemPerRow={this.onChangeItemPerRow} // Nombre d'article
        onClickOnglet={this.onClickOnglet}
      />
    );
  }
}

/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    data: state.IncidentstmdLoaded.data,
    error: state.IncidentstmdLoaded.error,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  IncidentstmdLoadedActionCreator,
  QualificationIncidentTmdActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/lapi-tmd/incidents/container.tsx